export const ShuffleTraitRarities = {
  Common: 'Common',
  Uncommon: 'Uncommon',
  Rare: 'Rare',
  UltraRare: 'Ultra Rare',
};

export const shuffleTraitRarityPercentages = {
  [ShuffleTraitRarities.Common]: 70,
  [ShuffleTraitRarities.Uncommon]: 20,
  [ShuffleTraitRarities.Rare]: 8,
  [ShuffleTraitRarities.UltraRare]: 2,
};

export const shuffleTraitDependencies = {
  Clothing: {
    'Avocado Suit': {
      Head: 'None',
      Whiskers: 'Normal',
    },
    'Watermelon Suit': {
      Head: 'None',
    },
    'Gum-ball Machine Suit': {
      Head: 'None',
    },
    Snake: {
      Accessory: 'None',
    },
  },
  Head: {
    'Shark Hat': {
      Eyes: 'Normal',
      Whiskers: 'Normal',
    },
    Cyborg: {
      Whiskers: 'Normal',
      Eyes: 'Normal',
    },
    Flower: {
      Whiskers: 'Normal',
    },
    'Fish Bowl - Normal': {
      Eyes: 'Normal',
      Whiskers: 'Normal',
    },
    'Fish Bowl - Skeleton': {
      Eyes: 'Normal',
      Whiskers: 'Normal',
    },
    TV: {
      Eyes: 'Normal',
      Whiskers: 'Normal',
    },
    'Trash Can Lid': {
      Eyes: 'Normal',
    },
    'Slime Eye': {
      Eyes: 'Normal',
      Whiskers: 'Normal',
    },
  },
  Accessory: {
    'Robot Hand': {
      Fur: 'Normal',
    },
  },
  Fur: {
    Bricks: {
      Clothing: 'None',
    },
    'Jake the Brick': {
      Clothing: 'None',
    },
  },
  Backgrounds: {},
  Eyes: {},
  Mouthes: {},
  Special: {},
  Whiskers: {},
};

const organizedTraits = {
  Fur: {
    [ShuffleTraitRarities.Common]: [
      'Normal',
      // 'Green',
      // 'Blue',
      'Black',
      // 'Orange',
      // 'White',
      // 'Gray',
    ],
    [ShuffleTraitRarities.Uncommon]: [],
    [ShuffleTraitRarities.Rare]: ['Cactus', 'Bricks'],
    [ShuffleTraitRarities.UltraRare]: ['Jake the Brick'],
  },
  Clothing: {
    [ShuffleTraitRarities.Common]: [
      // 'Track Suit - 230',
      // 'Track Suit - 420',
      'Track Suit - Black',
      'Track Suit - Blue',
      'Track Suit - Red',
      'Bolt T-Shirt',
      'Shitty Up T-Shirt',
      'Running Outfit',
    ],
    // 'Mockingjay', 'Crayon Belt',
    [ShuffleTraitRarities.Uncommon]: ['Hawaiian Shirt', 'Pot', 'Cow Suit'],
    [ShuffleTraitRarities.Rare]: [
      'Snake',
      // 'Blueberry Suit',
      'Avocado Suit',
      // 'Watermelon Suit',
      'Trash Can',
      'Pie Dress - Blueberry',
      'Pie Dress - Cherry',
    ],
    [ShuffleTraitRarities.UltraRare]: [
      'Chest Burster',
      // 'Gum-ball Machine Suit'
    ],
  },
  Accessory: {
    // 'Snowman',
    [ShuffleTraitRarities.Common]: ['Watermelon', 'Water Bottle'],
    [ShuffleTraitRarities.Uncommon]: ['White Russian', 'Ramen', 'TV Remote'],
    [ShuffleTraitRarities.Rare]: [],
    // 'Robot Hand',
    [ShuffleTraitRarities.UltraRare]: ['Slime Eye'],
  },
  Head: {
    // 'Braided Hair', 'Dazed', 'Messy Purple Wig',
    [ShuffleTraitRarities.Common]: ['Mouse Ears - Gray', 'Mouse Ears - Black', 'Cups', 'Flower'],
    [ShuffleTraitRarities.Uncommon]: [
      'Golden Medallion',
      // 'Blueberry Beret',
      'Tin Foil Hat',
    ],
    [ShuffleTraitRarities.Rare]: ['Cyborg', 'Trash Can Lid', 'TV', 'Fish Bowl - Normal', 'Fish Bowl - Skeleton'],
    [ShuffleTraitRarities.UltraRare]: ['Shark Hat', 'Slime Eye'],
  },
  Backgrounds: {
    [ShuffleTraitRarities.Common]: [
      'Green',
      'Violet',
      // 'Red'
    ],
    [ShuffleTraitRarities.Uncommon]: ['Yellow', 'Blue'],
    [ShuffleTraitRarities.Rare]: ['Gradient 1', 'Gradient 2', 'Gradient 3'],
    [ShuffleTraitRarities.UltraRare]: ['Clouds'],
  },
  Eyes: {},
};

const formatTrait = (trait, rarity) => ({
  name: trait,
  rarity,
});

export const shuffleTraits = {
  Fur: Object.entries(organizedTraits.Fur).flatMap(([rarity, traits]) => traits.map((trait) => formatTrait(trait, rarity))),
  Clothing: Object.entries(organizedTraits.Clothing).flatMap(([rarity, traits]) => traits.map((trait) => formatTrait(trait, rarity))),
  Accessory: Object.entries(organizedTraits.Accessory).flatMap(([rarity, traits]) => traits.map((trait) => formatTrait(trait, rarity))),
  Head: Object.entries(organizedTraits.Head).flatMap(([rarity, traits]) => traits.map((trait) => formatTrait(trait, rarity))),
  Background: Object.entries(organizedTraits.Backgrounds).flatMap(([rarity, traits]) => traits.map((trait) => formatTrait(trait, rarity))),
};

export const resolveTraitDependencies = (selectedTraits) => {
  const resolvedTraits = { ...selectedTraits };

  Object.entries(selectedTraits).forEach(([category, traitName]) => {
    if (traitName && shuffleTraitDependencies[category]?.[traitName]) {
      const dependencies = shuffleTraitDependencies[category][traitName];

      Object.entries(dependencies).forEach(([depCategory, depTraitName]) => {
        resolvedTraits[depCategory] = depTraitName;
      });
    }
  });

  return resolvedTraits;
};

export const getTraitDependencies = (category, traitName) => {
  return shuffleTraitDependencies[category]?.[traitName] || {};
};
